import { z } from "zod";
import {
  OrgContactSchema,
  OrgSchema,
  OrgStatsSchema,
  LocationSchema,
  UserSchema,
  OrgReviewSchema,
  OrgMemberSchema,
  CreditSchema,
  AccountSchema,
  ReferralStatsSchema,
} from "../models";

export const OrgRatingDistributionSchema = z
  .object({
    "1": z.number().int().min(0),
    "2": z.number().int().min(0),
    "3": z.number().int().min(0),
    "4": z.number().int().min(0),
    "5": z.number().int().min(0),
  })
  .default({
    "1": 0,
    "2": 0,
    "3": 0,
    "4": 0,
    "5": 0,
  });

export const OrgPublicDetailSchema = OrgSchema.extend({
  stats: OrgStatsSchema.extend({
    ratingDistribution: OrgRatingDistributionSchema,
  }),
  contact: OrgContactSchema,
  locations: z.array(LocationSchema),
});

export type OrgPublicDetail = z.infer<typeof OrgPublicDetailSchema>;

export const OrgReviewDetailSchema = OrgReviewSchema.extend({
  user: UserSchema,
});

export type OrgReviewDetail = z.infer<typeof OrgReviewDetailSchema>;

export const CreateOrgReviewSchema = OrgReviewSchema.omit({
  id: true,
  userId: true,
  createdAt: true,
  updatedAt: true,
});

export type CreateOrgReview = z.infer<typeof CreateOrgReviewSchema>;

export const OrgMemberDetailSchema = OrgMemberSchema.extend({
  org: OrgSchema.extend({
    stats: OrgStatsSchema,
  }),
});

export type OrgMemberDetail = z.infer<typeof OrgMemberDetailSchema>;

export const OrgMemberWithUserSchema = OrgMemberSchema.extend({
  user: UserSchema,
});

export type OrgMemberWithUser = z.infer<typeof OrgMemberWithUserSchema>;

export const OrgFullDetailSchema = OrgPublicDetailSchema.extend({
  stats: OrgStatsSchema.extend({
    ratingDistribution: OrgRatingDistributionSchema,
  }),
  account: AccountSchema.extend({
    stats: ReferralStatsSchema,
    credit: CreditSchema,
  }),
  contact: OrgContactSchema,
  locations: z.array(LocationSchema),
  members: z.array(OrgMemberWithUserSchema),
});

export type OrgFullDetail = z.infer<typeof OrgFullDetailSchema>;

export const UpdateOrgSchema = z.object({
  name: z.string().min(1).optional(),
  tagline: z.string().optional(),
  description: z.string().optional(),
  mission: z.string().optional(),
  avatar: z.string().url().optional(),
  cover: z.string().url().optional(),
  contact: z
    .object({
      email: z.string().email().nullable().optional(),
      phone: z.string().nullable().optional(),
      website: z.string().nullable().optional(),
      instagram: z.string().url().nullable().optional(),
      facebook: z.string().url().nullable().optional(),
      twitter: z.string().url().nullable().optional(),
      youtube: z.string().url().nullable().optional(),
    })
    .optional(),
});

export type UpdateOrg = z.infer<typeof UpdateOrgSchema>;
